"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getCurrentBroadcast", {
  enumerable: true,
  get: function get() {
    return _getCurrentBroadcast["default"];
  }
});
var _getCurrentBroadcast = _interopRequireDefault(require("./getCurrentBroadcast"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }